import React from "react";
import { Tooltip, createStyles, makeStyles, Theme } from "@material-ui/core";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headingImage: {
      width: 16,
      height: 16,
      objectFit: "contain",
      cursor: "pointer",
      verticalAlign: "top",
    }
  })
);

export interface expandType{
    isMinimize:boolean; clicked:any, keyDown:any, testid?: string
}

export const ExpandCollapse = (props: expandType) => {
    const {isMinimize, clicked, keyDown, testid} = props;
  const classes = useStyles();
  const iconMinimize = require("../../images/icon_minimize.svg")
const iconMaximize = require("../../images/icon_maximize.svg")
  return (
    <Tooltip title={isMinimize ? "Expand" : "Collapse"}>
      <img
        className={classes.headingImage}
        src={isMinimize ? iconMaximize : iconMinimize}
        alt={isMinimize ? "Maximize section" : "Minimize section"}
        onClick={clicked}
        onKeyDown={keyDown}
        data-testid={testid||"expand-collapse"}
      />
    </Tooltip>
  );
};
